import React from "react"; 
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import CloseIcon from "@mui/icons-material/Close";
import useMediaQuery from "@mui/material/useMediaQuery"; 
import "../../../Component/Common/ReuseableComponent/ReuseableComponent.css";
import Modal from "@mui/material/Modal";
import { PendingPoCard } from "./PendingPoCard";
import GCPendingPoCard from "./GCPendingPoCard";
import GCTitleSticky from "../../../Component/Common/ReuseableComponent/GCTitleSticky";
const GridDataColumn = [
  { field: "id", headerName: "ID", width: 70, hide: true },
];
const fDummyFunction=()=>{}
const GCPendingStock = ({
  xOpen = false,
  fCloseDetailModal, 
  xTitle = "Pending Po Detail",
  sPendingPoData 
}) => {
  const vMediaQuery = useMediaQuery("(max-width:650px)");

  return (
    <Modal
      open={xOpen}
      onClose={fCloseDetailModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{ flexGrow: 1, overflow: "auto" }}
        className="
        gnr-item-search 
        model-gc-search"
      >
         
        <GCTitleSticky title={xTitle} onClose={fCloseDetailModal} />
         
        <div className="p-2">
          
        {/* {sPendingPoData?.length > 0 && (
          <Box>
            <Grid
              container
              spacing={{ xs: 0, md: 3 }}
              columns={{ xs: 12, sm: 12, md: 12 }}
              className="easy-putaway-container"
            >
              {sPendingPoData?.map((obj, index) => (
                <Grid item xs={12} sm={12} md={4} key={index}>
                  <PendingPoCard
                    B_Itmcd={obj.itemCode}
                    // SuppRefNo1={obj.SuppRefNo1}
                    POQty={obj.POQty}
                    GRNQty={obj.GRNQty}
                    DiffQty={obj.DiffQty}
                    Name2={obj.itemName}
                    obj={obj}
                    
                    
                    onClick={() => { 
                    }}
                  />
                </Grid>
              ))}
            </Grid>
          </Box>
        )}  */}
        <GCPendingPoCard items={sPendingPoData}/>
        </div>
      </Box>
    </Modal>
  );
};

export default GCPendingStock;
